var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDay4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000014622991313494988050000004555693431412963988_);}\r\n\t.st2{fill:url(#SVGID_00000051366542357207017770000015514139851675272870_);}\r\n\t.st3{fill:url(#SVGID_00000131363411863706151820000002237195565701618323_);}\r\n\t.st4{fill:url(#SVGID_00000118382707457304793540000008504972023152968885_);}\r\n\t.st5{fill:url(#SVGID_00000003106938040963522500000000314325185380905891_);}\r\n\t.st6{fill:url(#SVGID_00000031886722195967227010000014349905502866002327_);}\r\n\t.st7{fill:url(#SVGID_00000044891087007503300780000013322844293048891289_);}\r\n\t.st8{fill:url(#SVGID_00000072976746891257319360000008679736006812250270_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.8882,
    y1: 32,
    x2: 48.229,
    y2: 32
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,48.2c-8.9,0-16.2-7.3-16.2-16.2s7.3-16.2,16.2-16.2c8.9,0,16.2,7.3,16.2,16.2S41,48.2,32.1,48.2z  M32.1,18.8c-7.3,0-13.2,5.9-13.2,13.2c0,7.3,5.9,13.2,13.2,13.2c7.3,0,13.2-5.9,13.2-13.2C45.2,24.7,39.3,18.8,32.1,18.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086688122811510668260000009923967846350402972_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.1079,
    y1: 31.3621,
    x2: 63.8335,
    y2: 31.3621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.1,
    y: 29.9,
    style: {
      fill: "url(#SVGID_00000086688122811510668260000009923967846350402972_)"
    },
    width: 10.7,
    height: 3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014624563599804089940000011356281799380799134_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1665,
    y1: 31.3621,
    x2: 10.8921,
    y2: 31.3621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 29.9,
    style: {
      fill: "url(#SVGID_00000014624563599804089940000011356281799380799134_)"
    },
    width: 10.7,
    height: 3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136384393638392723510000015511480672033123516_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.5005,
    y1: 5.5293,
    x2: 33.5005,
    y2: 5.5293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 0.2,
    style: {
      fill: "url(#SVGID_00000136384393638392723510000015511480672033123516_)"
    },
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142149574864362576870000002692704962164413863_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.5005,
    y1: 58.4707,
    x2: 33.5005,
    y2: 58.4707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 53.1,
    style: {
      fill: "url(#SVGID_00000142149574864362576870000002692704962164413863_)"
    },
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008120250242826821960000012508337774612376511_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.5952,
    y1: 11.752,
    x2: 17.3013,
    y2: 11.752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000008120250242826821960000012508337774612376511_)"
    },
    points: "15.2,16.6 7.6,9 9.7,6.9  17.3,14.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043432642334051772070000006360140184302639543_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0308,
    y1: 49.187,
    x2: 54.7368,
    y2: 49.187
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000043432642334051772070000006360140184302639543_)"
    },
    points: "52.6,54 45,46.5 47.2,44.3  54.7,51.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165199794837844620510000017980415273192837530_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.5952,
    y1: 49.6968,
    x2: 17.3013,
    y2: 49.6968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000165199794837844620510000017980415273192837530_)"
    },
    points: "9.7,54.5 7.6,52.4 15.2,44.8  17.3,47  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090976624425635441960000008534826287164549800_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0308,
    y1: 12.2615,
    x2: 54.7368,
    y2: 12.2615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000090976624425635441960000008534826287164549800_)"
    },
    points: "47.2,17.1 45,15 52.6,7.4  54.7,9.5  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDay4);
export default __webpack_public_path__ + "static/media/icon_day4.5f6ec79739c1bf44bbeab3e50298fd4f.svg";
export { ForwardRef as ReactComponent };